import React, { useState, useEffect } from 'react';

// Services
import { getInventario } from '../../../services/StoreService';
import { generarPDFCotizacion } from '../../../services/PdfVentasService';

// Estilos
import '../../static/Global.css';
import '../../static/Home.css';
import '../../static/Aside.css';
import '../../static/Flotante.css';
import '../../static/RegistrarMovimiento.css';



const RegistrarCotizacion = ({ usuarioLogueado = "Usuario Novatech" }) => {
    const [vendedor, setVendedor] = useState({ id: null, nombre: "Cargando..." });
    const [busqueda, setBusqueda] = useState('');
    const [productosDB, setProductosDB] = useState([]);
    const [carrito, setCarrito] = useState([]);
    const [total, setTotal] = useState(0);

useEffect(() => {
    const userSession = sessionStorage.getItem('usuario_novatech') || localStorage.getItem('usuario_novatech');
    
    if (userSession) {
        try {
            const user = JSON.parse(userSession);
            setVendedor({
                id: user.id,
                nombre: user.nombre // Solo jalamos el nombre
            });
        } catch (e) {
            console.error("Error al recuperar el nombre:", e);
            setVendedor({ id: null, nombre: "Error" });
        }
    } else {
        setVendedor({ id: null, nombre: "Invitado" });
    }
}, []);

    // 1. Carga inicial de productos
    useEffect(() => {
        const fetchProds = async () => {
            try {
                const data = await getInventario();
                setProductosDB(data);
            } catch (error) {
                console.error("Error cargando inventario:", error);
            }
        };
        fetchProds();
    }, []);

    // 2. Recalcular total automáticamente al cambiar el carrito
    useEffect(() => {
        const nuevoTotal = carrito.reduce((acc, item) => acc + item.subtotal, 0);
        setTotal(nuevoTotal);
    }, [carrito]);

    // 3. Lógica para bajar el producto a la tabla
    const agregarAlCarrito = (prod) => {
        // Buscamos si ya está en el carrito
        const existe = carrito.find(item => item.articulo_id === prod.productos_id);
        
        if (existe) {
            // Si existe, solo aumentamos cantidad usando la función de actualización
            actualizarCantidad(prod.productos_id, existe.cantidad + 1);
        } else {
            // Si es nuevo, lo agregamos con los campos necesarios para la tabla
            const nuevoItem = {
                articulo_id: prod.productos_id,
                nombre: prod.nombre,
                precio_venta: parseFloat(prod.precio_venta), // Aseguramos que sea número
                cantidad: 1,
                subtotal: parseFloat(prod.precio_venta) // Inicialmente es 1 * precio
            };
            setCarrito([...carrito, nuevoItem]);
        }
        
        // Limpiar buscador para poder buscar el siguiente producto rápido
        setBusqueda('');
    };

    // 4. Lógica de actualización de cantidad y subtotal
    const actualizarCantidad = (id, nuevaCant) => {
        if (nuevaCant < 1) return; // Evitar cantidades negativas o cero

        setCarrito(prevCarrito => 
            prevCarrito.map(item => {
                if (item.articulo_id === id) {
                    const cantCalculada = Number(nuevaCant);
                    return { 
                        ...item, 
                        cantidad: cantCalculada, 
                        subtotal: cantCalculada * item.precio_venta 
                    };
                }
                return item;
            })
        );
    };


    const quitarProducto = (id) => {
        setCarrito(carrito.filter(item => item.articulo_id !== id));
    };


    const cancelarCotizacion = () => {
        if (window.confirm("¿Estás seguro de cancelar la cotizacion actual?")) {
            setCarrito([]);
            setBusqueda('');
        }
    };

    const actualizarPrecio = (id, nuevoPrecio) => {
    const precio = parseFloat(nuevoPrecio) || 0;

    setCarrito(prevCarrito => 
        prevCarrito.map(item => {
            if (item.articulo_id === id) {
                return { 
                    ...item, 
                    precio_venta: precio, 
                    subtotal: item.cantidad * precio 
                };
            }
            return item;
        })
    );

    };

    const actualizarNombre = (id, nuevoNombre) => {
    setCarrito(prevCarrito => 
        prevCarrito.map(item => {
            if (item.articulo_id === id) {
                return { 
                    ...item, 
                    nombre: nuevoNombre 
                };
            }
            return item;
        })
    );
    
    };

    const procesarCotizacion = () => {

        if (carrito.length === 0) return alert("Agrega al menos un producto para la cotización");

        // Creamos un ID temporal para el PDF (Formato: COT-AñoMesDía-HoraMin)
        const fechaActual = new Date();
        const cot_id = `COT-${fechaActual.getFullYear()}${(fechaActual.getMonth() + 1)}${fechaActual.getDate()}-${fechaActual.getHours()}${fechaActual.getMinutes()}`;

        try {
            // --- LLAMADA AL SERVICE DEL PDF ---
            // Usamos la misma estructura que ventas pero lo identificamos como cotización
            generarPDFCotizacion({
                venta_id: cot_id, // Usamos nuestro ID temporal
                usuario: vendedor.nombre,
                detalles: carrito.map(item => ({
                    articulo_id: item.articulo_id,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    precio_venta: item.precio_venta,
                    subtotal: item.subtotal
                })),
                total: total
            });

            // Limpiamos todo después de generar el PDF
            alert(`✅ Cotización generada con éxito.`);
            setCarrito([]); 
            setBusqueda(''); 
        } catch (err) {
            alert(`❌ Error al generar el PDF: ${err.message}`);
        }

    };

    // Filtrado de búsqueda
    const productosFiltrados = busqueda.length > 0 
        ? productosDB.filter(p => p.nombre.toLowerCase().includes(busqueda.toLowerCase()))
        : [];

    return (
        <div className="venta-container">
            <header className="venta-header">

                <h2>Registrar Cotizacion</h2>
                
            <div className="user-info">
                Vendedor: <i className="fa fa-user-circle" style={{ marginRight: '5px' }}></i> 
                <strong style={{ color: '#2c3e50' }}>{vendedor.nombre}</strong>
                {vendedor.rol && (
                    <span className="badge-rol">{vendedor.rol}</span>
                )}
            </div>

            </header>

            <div className="venta-layout">
                <div className="venta-main">
                    <div className="search-box">
                        <input 
                            type="text" 
                            placeholder="Buscar producto (Ej: Teclado, Mouse...)" 
                            value={busqueda}
                            onChange={(e) => setBusqueda(e.target.value)}
                            autoFocus
                        />
                        {productosFiltrados.length > 0 && (
                            <ul className="search-results">
                                {productosFiltrados.map(p => (
                                    <li key={p.productos_id} onClick={() => agregarAlCarrito(p)}>
                                        <div className="res-info">
                                            <strong>{p.nombre}</strong>
                                            <span>S/ {p.precio_venta}</span>
                                        </div>
                                        <span className="res-stock">Stock: {p.stock}</span>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>

                    <table className="novatech-table">
                        <thead>
                            <tr>
                                <th>Producto</th>
                                <th>Precio</th>
                                <th style={{ width: '120px' }}>Cantidad</th>
                                <th>Subtotal</th>
                                <th>Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {carrito.length === 0 ? (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                                        No hay productos en la venta. Usa el buscador arriba.
                                    </td>
                                </tr>
                            ) : (
                                carrito.map(item => (
                                    <tr key={item.articulo_id}>
                                        <td>
                                            <input 
                                                type="text" 
                                                className="input-edit-nombre" // Puedes crear esta clase en CSS
                                                value={item.nombre} 
                                                onChange={(e) => actualizarNombre(item.articulo_id, e.target.value)}
                                                style={{
                                                    border: 'none',
                                                    borderBottom: '1px solid #ddd',
                                                    width: '100%',
                                                    background: 'transparent',
                                                    padding: '5px'
                                                }}
                                            />
                                        </td>
                                        <td>
                                         <div className="price-edit-container">
                                          <span>S/ </span>
                                          <input 
                                             type="number" 
                                             className="input-edit-precio"
                                             value={item.precio_venta} 
                                             onChange={(e) => actualizarPrecio(item.articulo_id, e.target.value)}
                                             step="0.10"
                                             min="0"
                                             />
                                         </div>
                                       </td>
                                        <td>
                                            <div className="qty-controls">
                                                <button onClick={() => actualizarCantidad(item.articulo_id, item.cantidad - 1)}>-</button>
                                                <span>{item.cantidad}</span>
                                                <button onClick={() => actualizarCantidad(item.articulo_id, item.cantidad + 1)}>+</button>
                                            </div>
                                        </td>
                                        <td>S/ {item.subtotal.toFixed(2)}</td>
                                        <td>
                                            <button className="btn-remove" onClick={() => quitarProducto(item.articulo_id)}>
                                                <i className="fa fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                <aside className="venta-summary">
                    <div className="total-card">
                        <span className="total-label">TOTAL A PAGAR</span>
                        <span className="total-amount">S/ {total.toFixed(2)}</span>
                    </div>

                    <div className="venta-actions">
                        <button className="btn-confirm" onClick={procesarCotizacion} disabled={carrito.length === 0}>
                            <i className="fa fa-check"></i> GENERAR COTIZACION
                        </button>
                        <button className="btn-cancel-venta" onClick={cancelarCotizacion}>
                            <i className="fa fa-times"></i> CANCELAR
                        </button>
                    </div>
                </aside>
            </div>
        </div>
    );
};

export default RegistrarCotizacion;